import { useEffect, useState, useRef } from "react";
import { io, Socket } from "socket.io-client";

interface ExchangeRateData {
  source: string;
  pair: string;
  rate: number;
  markup: string;
  timestamp: string;
}

interface UseExchangeRateSocketReturn {
  exchangeRate: ExchangeRateData | null;
  isConnected: boolean;
  error: string | null;
}

export const useExchangeRateSocket = (
  backendUrl: string = "http://localhost:3001"
): UseExchangeRateSocketReturn => {
  const [exchangeRate, setExchangeRate] = useState<ExchangeRateData | null>(
    null
  );
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    // Создаем WebSocket соединение
    const socket = io(`${backendUrl}/exchange-rates`, {
      transports: ["websocket", "polling"],
      timeout: 20000,
      autoConnect: true,
    });

    socketRef.current = socket;

    // Обработчики событий
    socket.on("connect", () => {
      console.log("🔗 WebSocket connected to exchange rates");
      setIsConnected(true);
      setError(null);
    });

    socket.on("disconnect", () => {
      console.log("🔌 WebSocket disconnected from exchange rates");
      setIsConnected(false);
    });

    socket.on("connect_error", (err) => {
      console.error("❌ WebSocket connection error:", err);
      setError(err.message);
      setIsConnected(false);
    });

    socket.on("connected", (data) => {
      console.log("✅ WebSocket handshake:", data);
    });

    // Основной обработчик обновлений курса
    socket.on("exchange-rate-update", (data: ExchangeRateData) => {
      console.log("📈 Exchange rate update received:", data);
      setExchangeRate(data);
      setError(null);
    });

    // Cleanup при размонтировании
    return () => {
      console.log("🧹 Cleaning up WebSocket connection");
      socket.disconnect();
      socketRef.current = null;
    };
  }, [backendUrl]);

  return {
    exchangeRate,
    isConnected,
    error,
  };
};
